import React from 'react';
import BrandPolicyPage from '../PolicyPage/BrandPolicyPage';

const HostAgreementPage: React.FC = () => <BrandPolicyPage doc="host-agreement" />;

export default HostAgreementPage;
